
import { mapGetters } from 'vuex'
import LoleWishlistBenefits from '../components/wishlist/lole-wishlist-benefits'
import LoleSignin from '../components/signin/lole-signin'
import LoleSignup from '../components/signup/lole-signup'
import LoleBtn from '~/components/buttons/lole-btn'
import generateHeader from '~/helpers/header'

export default {
  name: 'PageSignIn',
  components: {
    LoleBtn,
    LoleWishlistBenefits,
    LoleSignin,
    LoleSignup,
  },
  middleware: 'guest',
  async asyncData({ error, app: { $storyblok, $sentryException, $gtm } }) {
    let wordingSignIn = {}
    let wordingSignUp = {}
    try {
      const pageInfo = await $storyblok.getStory(`/pages/signin_page`)
      wordingSignIn = pageInfo.story.content
      const pageInfo2 = await $storyblok.getStory(`/pages/signup_page`)
      wordingSignUp = pageInfo2.story.content
    } catch (e) {
      $sentryException(e, {
        source: 'storyblok',
        level: 'warning',
        extra: 'Call storyblok signin_page, signin_page failed',
      })
      error({
        statusCode: 500,
        message: 'Call storyblok signin_page, signin_page failed',
      })
    }
    try {
      $gtm.push({
        ecommerce: undefined,
        product: undefined,
        search: undefined,
      })
      $gtm.push({ 'page.type': 'authentification' })
    } catch (e) {
      $sentryException(e, {
        source: 'GTM page authentification',
        level: 'warning',
        extra: 'GTM page authentification failed',
      })
    }
    return { wordingSignIn, wordingSignUp }
  },
  data: () => ({
    vueSignIn: true,
    wordingSignIn: null,
    wordingSignUp: null,
  }),
  head() {
    if (!this.wordingSignIn.SEO) return
    this.wordingSignIn.SEO.og_image = this.wordingSignIn.SEO.og_image
      ? this.wordingSignIn.SEO.og_image
      : this.$config.DEFAULT_OG_IMAGE
    return generateHeader({
      ...this.wordingSignIn.SEO,
      path: this.$route.path,
    })
  },
  computed: {
    isMobile() {
      return !this.$store.getters['responsive/getIsWindowLarge']
    },
    isWishlistFlow() {
      const qs = this.$route.query
      const routeToWishlist = 'wishlist' in qs
      return routeToWishlist
    },
    ...mapGetters({
      vxWordingWlHero: 'common/getCommonWishlistStory',
      vxWordingErrors: 'common/getErrorsForm',
    }),
  },
  mounted() {
    if (this.$router.history.current.query.signup === 'true')
      this.vueSignIn = false
  },
  methods: {
    toggleVue() {
      this.vueSignIn = !this.vueSignIn
    },
  },
}
